import React, { Component } from 'react';
import List from './List';
import Form from './Form';
import TabbablePage from '../../components/TabbablePage';
import DocumentTitle from 'react-document-title';

export default class Page extends React.Component {
	render() {
		return (
			<DocumentTitle title="E-mailové účty">
				<TabbablePage
					module="emailaccount"
					List={List}
					Form={Form}
					newTitle="Nový"
					listTitle="Seznam účtů"
					{...this.props}
				/>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Emailaccount/Page.js